import { useTranslation } from 'react-i18next';

import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import type { GridRenderCellParams } from '@packages/fenrir/components';
import { Typography } from '@packages/fenrir/components';

export const BooleanCell = (params: GridRenderCellParams) => {
  const { t: tUi } = useTranslation('ui');
  if (params.value == null) {
    return <NoDataEnDash />;
  }

  return (
    <Typography variant="body2">
      {params.value ? tUi('yes') : tUi('no')}
    </Typography>
  );
};
